import wrappedLocalStorage from 'flow/utils/local-storage-utils';
import { isArray } from 'lodash';
import { secondsToMinutesAndSeconds } from 'flow/utils/date-time-utils';

export const QUEUE_SERVICE_LEVELS_KEY = 'QUEUE_SERVICE_LEVELS';
export const CHANNEL_SERVICE_LEVELS_KEY = 'CHANNEL_SERVICE_LEVELS';
const oneMinute = 60;
const twoMinutes = 120;

export const getFormattedServiceLevel = (serviceLevel, i18next) => {
    const { m, s } = secondsToMinutesAndSeconds(serviceLevel);
    const min = i18next.t('duration.min');
    const sec = i18next.t('duration.sec');
    let formattedServiceLevel = '';

    if (serviceLevel < 0) {
        formattedServiceLevel = '';
    } else if (m && s) {
        formattedServiceLevel = `${m} ${min}, ${s} ${sec}`;
    } else if (m) {
        formattedServiceLevel = `${m} ${min}`;
    } else if (s) {
        formattedServiceLevel = `${s} ${sec}`;
    } else {
        formattedServiceLevel = `0 ${min}`;
    }

    return formattedServiceLevel;
};

export const getServiceLevelsForQueue = (queueId) => {
    return getServiceLevels(QUEUE_SERVICE_LEVELS_KEY, queueId);
};

export const setServiceLevelsForQueue = (queueId, serviceLevels) => {
    return setServiceLevels(QUEUE_SERVICE_LEVELS_KEY, queueId, serviceLevels);
};

// Setting custom service levels for channels are not yet implemented so
// getServiceLevelsForChannel and setServiceLevelsForChannel are not used.
// Remove this comment when we implement it for channels.
export const getServiceLevelsForChannel = (channelId) => {
    return getServiceLevels(CHANNEL_SERVICE_LEVELS_KEY, channelId);
};

export const setServiceLevelsForChannel = (channelId, serviceLevels) => {
    return setServiceLevels(
        CHANNEL_SERVICE_LEVELS_KEY,
        channelId,
        serviceLevels,
    );
};

export const getServiceLevels = (key, id) => {
    if (!key || !id) {
        return [oneMinute, twoMinutes];
    }

    const allServiceLevels = JSON.parse(wrappedLocalStorage.getItem(key)) || {};
    const serviceLevels = allServiceLevels[id] || [];

    const level1 = isNaN(serviceLevels[0]) ? oneMinute : serviceLevels[0];
    const level2 = isNaN(serviceLevels[1]) ? twoMinutes : serviceLevels[1];

    return [level1, level2];
};

export const setServiceLevels = (key, id, serviceLevels) => {
    if (!key || !id) {
        return;
    }

    if (
        isArray(serviceLevels) &&
        !serviceLevels.some((level) => isNaN(level))
    ) {
        const allServiceLevels =
            JSON.parse(wrappedLocalStorage.getItem(key)) || {};

        const updatedServiceLevels = {
            ...allServiceLevels,
            [id]: serviceLevels,
        };

        wrappedLocalStorage.setItem(key, JSON.stringify(updatedServiceLevels));
    }
};
